// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.payload.TransferPayload
import org.mifos.mobile.core.model.entity.templates.account.AccountOptionsTemplate

@OptIn(InternalKtorfitApi::class)
public class _ThirdPartyTransferServiceImpl(
  private val _ktorfit: Ktorfit,
) : ThirdPartyTransferService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun accountTransferTemplate(): Flow<AccountOptionsTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "accounttransfers/template?type=tpt")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<AccountOptionsTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun makeTransfer(transferPayload: TransferPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "accounttransfers?type=tpt")
        }
        setBody(transferPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }
}

public class _ThirdPartyTransferServiceProvider : ClassProvider<ThirdPartyTransferService> {
  override fun create(_ktorfit: Ktorfit): ThirdPartyTransferService = _ThirdPartyTransferServiceImpl(_ktorfit)
}

public fun Ktorfit.createThirdPartyTransferService(): ThirdPartyTransferService = _ThirdPartyTransferServiceImpl(this)
